import { NavigationItem } from '@app/components/navigation/NavigationItem';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Navigation } from '@typings';
import { useTranslation } from 'react-i18next';

import { ExpandableItem } from './ExpandableItem';

interface Props {
  navigationItems: Navigation.Item[];
}

export const PagesSection = ({ navigationItems }: Props) => {
  const { t } = useTranslation(['common']);
  const itemProps = {
    activeClassName: 'bg-neutral-96 hover:bg-neutral-90 body-1',
    className:
      'block overflow-hidden w-full text-ellipsis rounded-regular px-2 py-[0.375rem] transition-colors body-2 hover:bg-neutral-96 focus-visible:focus-outline',
  };

  if (isEmpty(navigationItems)) {
    return null;
  }

  return (
    <nav>
      <h2 className="mb-1 text-neutral-60 heading-4">{t('common:page_other')}</h2>
      <ul className="mx-2 flex flex-col gap-1">
        {navigationItems.map((item, index) => {
          if (item.type === 'link' || !isDefined(item.children) || isEmpty(item.children)) {
            return (
              <li key={index}>
                <NavigationItem item={item} {...itemProps} />
              </li>
            );
          }

          return <ExpandableItem key={index} item={item} {...itemProps} />;
        })}
      </ul>
    </nav>
  );
};
